// 车牌识别
export default {
    licensePlate: 'автомобильный номер',
    pictureName: 'Название изображения',
    identificationPeriod: 'Срок признания',
    identified: 'Признанный',
    unrecognized: 'непризнанно',
    IR: 'Результат признания',
    reliability: 'Достоверность',
    LPR: 'Узнай номерной знак',
    PEAN: 'Пожалуйста, введите имя',
    TLIB: 'Длина от 1 до 20 знаков',
}